<template>
  <a-result
    status="500"
    title="5xx"
    sub-title="抱歉，服务器错误"
    style="padding-top: 128px"
  >
  </a-result>
</template>

<script>
export default {
  name: 'Error5xx'
}
</script>
